module.exports = __webpack_public_path__ + "img/ipayment.c3311e74.svg";